import templatesManager from 'services/widget_basic_resources/templates_manager';
import routeHandler from './routeHandler';
import {checkoutShell as frontendShell} from '@edreamsodigeo/frontend-shell';

Odigeo.start({
    router: {
        routes: {
            'checkout_passengers/:bookingId': 'checkout_passengers',
            'checkout_payment/:bookingId': 'checkout_payment',
            'waiting_passengers/': 'waiting_passengers',
            'ancillaries/:bookingId': 'checkout_ancillaries',
            'prime_subscription/:bookingId': 'checkout_prime_subscription',
            'confirm_booking/:bookingId': 'confirm_booking',
            'prime_booking_error/:bookingId': 'prime_booking_error',
        },
        handlers: {
            ...routeHandler(frontendShell, 'checkout_passengers'),
            ...routeHandler(frontendShell, 'checkout_payment'),
            ...routeHandler(frontendShell, 'waiting_passengers'),
            ...routeHandler(frontendShell, 'checkout_ancillaries'),
            ...routeHandler(frontendShell, 'checkout_prime_subscription'),
            ...routeHandler(frontendShell, 'confirm_booking'),
            ...routeHandler(frontendShell, 'prime_booking_error'),
        },
        appChangePages: {
            flightscheckout: {
                flightinfo: 'travelsecure',
                payment: 'travelsecure',
                results: 'home',
                home: 'homeflights',
            },
        },
    },
    templatesManager: templatesManager,
    settings: {
        pathNames: {
            travelsecure: '/travel/secure/',
            homeflights: '/',
            home: '/travel/',
            flightscheckout: '/flights/checkout/',
            checkout_payment: '/flights/checkout/',
            ancillaries: '/flights/checkout/',
            prime_subscription: '/flights/checkout',
            confirm_booking: '/flights/checkout/',
            prime_booking_error: '/flights/checkout/',
        },
    },
});
